'use client';
import { useRouter } from '@/i18n/navigation';
import { useEffect } from 'react';

export function useAppRouter(
  prefetchUrls: string[] = []
) {
  const router = useRouter();

  // Prefetch all provided URLs on mount
  useEffect(() => {
    prefetchUrls.forEach((url) => {
      if (url) router.prefetch(url);
    });
  }, [prefetchUrls, router]);

  // Single function for navigation
  const navigate = (url: string, method: 'push' | 'replace' = 'push') => {
    if (method === 'replace') router.replace(url);
    else router.push(url);
  };

  return { navigate };
}
